import { ItemKind } from "dto/IKindItems";
import { TagType } from "dto/ITag";
import { ListType } from "dto/ListType";

export const getTagType = (kind: ItemKind) => {
  switch (kind) {
    case ItemKind.Task:
      return TagType.Tasks;
    case ItemKind.CalendarEvent:
      return TagType.Events;
    case ItemKind.Participant:
      return TagType.Participants;
    case ItemKind.Cases:
      return TagType.Cases;
    case ItemKind.DossierFolder:
      return TagType.Folder;
    default:
      return TagType.Incoming;
  }
};

export const getListType = (kind: ItemKind) => {
  switch (kind) {
    case ItemKind.Task:
      return ListType.Tasks;
    case ItemKind.Participant:
      return ListType.Participants;
    case ItemKind.Cases:
      return ListType.Cases;
    case ItemKind.EditorDocument:
      return ListType.EditorDocuments;
    case ItemKind.LegalPerson:
      return ListType.LegalPersonVerification;
    default:
      return ListType.Incoming;
  }
};
